// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"e50cff81","4147":"56bbcc64","9651":"193fc803"}[chunkId] + "-1791925754620.js";
};